import { createRouter, createWebHistory } from "vue-router";
// The home page is in the main bundle so it renders without another request.
// Every other page is its own chunk, downloaded when it is first opened.
// Search and flight info are also prefetched when the browser is idle.
import HomeComponent from "../components/HomeComponent.vue";
const SearchResult = () => import(/* webpackChunkName: "search", webpackPrefetch: true */ "../components/SearchResult.vue");
const FlightInfo = () => import(/* webpackChunkName: "flight-info", webpackPrefetch: true */ "../components/flightInfo.vue");
const login = () => import(/* webpackChunkName: "login" */ "../components/loginCom.vue");
const register = () => import(/* webpackChunkName: "register" */ "../components/registerCom.vue");
const loader = () => import(/* webpackChunkName: "loader" */ "../components/loaderComponent.vue");
const ConfirmBook = () => import(/* webpackChunkName: "confirm-book" */ "../components/confirmBook.vue");
const BookingView = () => import(/* webpackChunkName: "booking-view" */ "../components/bookingView.vue");
const aboutUs = () => import(/* webpackChunkName: "about-us" */ "../components/aboutUs.vue");
const contactPage = () => import(/* webpackChunkName: "contact" */ "../components/contactPage.vue");
const privacyPolicy = () => import(/* webpackChunkName: "privacy-policy" */ "../components/privacyPolicy.vue");
const termUse = () => import(/* webpackChunkName: "terms-of-use" */ "../components/termUse.vue");
const myBooking = () => import(/* webpackChunkName: "my-booking" */ "../components/myBooking.vue");
const pageError = () => import(/* webpackChunkName: "page-error" */ "../components/pageError.vue");
const pageNot = () => import(/* webpackChunkName: "page-not-found" */ "../components/pageNot.vue");
const newPassword = () => import(/* webpackChunkName: "new-password" */ "@/components/newPassword.vue");
const myProfile = () => import(/* webpackChunkName: "my-profile" */ "../components/myProfile.vue");
const testCom = () => import(/* webpackChunkName: "test" */ "../components/testCom.vue");
const viewBooking = () => import(/* webpackChunkName: "view-booking" */ "../components/viewBooking.vue");
const seatMapping = () => import(/* webpackChunkName: "seat-map" */ "../components/seatMapping.vue");
const robotsCom = () => import(/* webpackChunkName: "robots" */ "../components/robotsCom.vue");
const sitemapCom = () => import(/* webpackChunkName: "sitemap" */ "../components/sitemapCom.vue");
const BlogPage = () => import(/* webpackChunkName: "blog" */ "../components/BlogPage.vue");
const BlogDetail = () => import(/* webpackChunkName: "blog-detail" */ "../components/BlogDetail.vue");
const BookingConfirmation = () => import(/* webpackChunkName: "booking-confirmation" */ "../components/bookingConfirmation.vue");
const routes = [
  {
    path: "/",
    component: HomeComponent,
  },
  
  {
    path: "/robots.txt",
    component: robotsCom,
  },
  {
    path: "/sitemap.xml",
    component: sitemapCom,
  },
  {
    path:"/blog",
    component: BlogPage,
  },
  {
    path:"/blog/:id",
    component: BlogPage,
  },
  { 
    path: '/blog/find/:id',
    component: BlogDetail,
    props: true 
  },
  { 
    path: '/blog/post/:id',
    component: BlogDetail,
    props: true 
  },
  {
    path: "/flight/search",
    component: SearchResult,
  },
  {
    path: "/flightInfo",
    component: FlightInfo,
  },
  {
    path: "/login",
    component: login,
  },
  {
    path: "/register",
    component: register,
  },
  {
    path: "/confirmBook",
    component: ConfirmBook,
  },
    {
    path: "/bookingConfirmation",
    component: BookingConfirmation,
  },
  {
    path: "/bookingView",
    component: BookingView,
  },
  {
    path: "/loader",
    component: loader,
  },
  {
    path: "/aboutUs",
    component: aboutUs,
  },
  {
    path: "/contactPage",
    component: contactPage,
  },
  {
    path: "/page/privacy-policy",
    component: privacyPolicy,
  },
  {
    path: "/page/terms-of-use",
    component: termUse,
  },
  {
    path: "/myBooking",
    component: myBooking,
  },
  {
    path: "/pageError",
    component: pageError,
  },
  {
    path: "/pageNot",
    component: pageNot,
  },
  {
    path: "/newPassword",
    component: newPassword,
  },
  {
    path: "/myProfile",
    component: myProfile,
  },
  {
    path:"/test",
    component:testCom
  },
  {
    path:"/viewBooking",
    component:viewBooking
  },
  {
    path:"/seatmap",
    component:seatMapping
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // If there's a saved position (e.g., back/forward navigation), use it
    if (savedPosition) {
      return savedPosition;
    }

    // If navigating to a new page, ensure it renders from the top
    if (to.path !== from.path) {
      return { top: 0, behavior: "instant" };
    }

    // Otherwise, do nothing (prevents scrolling to top during rendering)
    return false;
  },
});

// After a deploy, a tab opened before it can ask for a page chunk that no
// longer exists. Load that page fresh, once, so it gets the new chunks.
router.onError((error, to) => {
  const message = (error && error.message) || "";
  const isChunkError =
    (error && error.name === "ChunkLoadError") ||
    /Loading (CSS )?chunk .+ failed/i.test(message);
  if (!isChunkError) return;

  const retryKey = `chunk-retry:${to.fullPath}`;
  try {
    if (sessionStorage.getItem(retryKey)) return;
    sessionStorage.setItem(retryKey, "1");
  } catch (e) {
    return;
  }
  window.location.assign(to.fullPath);
});

router.afterEach((to) => {
  try {
    sessionStorage.removeItem(`chunk-retry:${to.fullPath}`);
  } catch (e) {
    // Storage blocked: nothing to clear.
  }
});

export default router;
